import React from 'react';
import {ViewStyle, TextStyle} from 'react-native';
import {Bookmark} from 'lucide-react-native';
import {useTranslation} from 'react-i18next';
import {ActionButton} from "@/components/common/ActionButton";
import {useVideoBookmark} from "@/data/user-data-hooks";

interface BookmarkButtonProps {
    orgId: string;
    videoId: string;
    variant?: 'default' | 'compact' | 'icon-only';
    size?: 'small' | 'medium' | 'large';
    style?: ViewStyle;
    textStyle?: TextStyle;
    disableMinWidth?: boolean; // New prop to disable minWidth when used in flex layouts
}

export const BookmarkButton: React.FC<BookmarkButtonProps> = ({
                                                                  orgId,
                                                                  videoId,
                                                                  variant = 'default',
                                                                  size = 'medium',
                                                                  style,
                                                                  textStyle
                                                              }) => {
    const {t} = useTranslation();
    const {isBookmarked, toggleBookmark} = useVideoBookmark(orgId, videoId);

    const getText = () => {
        if (variant === 'compact') {
            return isBookmarked ? t('media.bookmark.saved') : t('media.bookmark.save');
        }
        return isBookmarked ? t('media.bookmark.bookmarkedLabel') : t('media.bookmark.bookmarkLabel');
    };

    return (
        <>
            <ActionButton icon={Bookmark} text={getText()} onPress={toggleBookmark} isActive={isBookmarked} size={size}
                          style={style} textStyle={textStyle}/>
        </>
    );
};
